<div class="column-dialog">
  <h1 mat-dialog-title>{{ 'DataTable.Columns.Customize' | translate:locale.language }}</h1>
  <div mat-dialog-content>
    <p id="selectedColumnsLabel"><strong>{{ 'DataTable.Columns.Selected' | translate:locale.language }}</strong></p>
    @if (data?.displayedColumns) {
      <mat-selection-list cdkDropList (cdkDropListDropped)="dropSelectedColumn($event)"
        [cdkDropListData]="data.displayedColumns"
        [(ngModel)]="data.displayedColumns" aria-labelledby="selectedColumnsLabel">
        @for (column of data.displayedColumns; track column) {
          <div cdkDrag>
            <mat-list-option #colOption [value]="column" [disabled]="isLocked(column)"
              [attr.data-test]="'columns-selected-' + column">
              <mat-icon matListItemIcon>drag_handle</mat-icon>
              <div matListItemTitle>
                {{ getName(column) | translate:locale.language }}
                @if (colOption.disabled) {
                  ({{ 'required' | translate:locale.language }})
                }
                <div *cdkDragPreview class="drag-item">{{ getName(column) | translate:locale.language }}</div>
              </div>
            </mat-list-option>
          </div>
        }
      </mat-selection-list>
    }
    <p id="availableColumnsLabel"><strong>{{ 'DataTable.Columns.Available' | translate:locale.language }}</strong></p>
    @if (filteredAvailableColumns) {
      <mat-selection-list (selectionChange)="onColumnSelected($event)" aria-labelledby="availableColumnsLabel">
        @for (column of filteredAvailableColumns; track column.field) {
          <mat-list-option [disabled]="column.locked"
            [selected]="isSelected(column)" [value]="column" [attr.data-test]="'columns-available-' + column.field">
            <div matListItemTitle>
              {{ column.localizationKey ?? column.field | translate:locale.language }}
              @if (column.locked) {
                ({{ 'required' | translate:locale.language }})
              }
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    }
  </div>
  <div mat-dialog-actions class="button-row right">
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate:locale.language }}</button>
    @if (data) {
      <button mat-button [mat-dialog-close]="data.displayedColumns" cdkFocusInitial>{{ 'OK' |
      translate:locale.language }}</button>
    }
  </div>
</div>